// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderSummaryModal_order-summary-modal__sYmT9 {
  width: 116rem;
  max-width: 100%;
}
.OrderSummaryModal_order-summary-modal__content__4Pmni {
  max-width: 95rem;
  margin-inline: auto;
}

.OrderSummaryModal_order-summary-table__item-name-title__U28WJ {
  color: var(--gray-dark);
  font-size: var(--text-sm);
  font-weight: 500;
  line-height: 1.8rem;
}

.OrderSummaryModal_order-summary-table__sku-name__FyFbl {
  margin-top: 0.9rem;
  color: #000;
  font-size: var(--text-base);
  font-weight: 500;
}

.OrderSummaryModal_order-summary-table__bundle-skus-list__ji2uP {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
}

.OrderSummaryModal_order-summary-table__bundle-sku-list-item__ZbXZx {
  color: #000;
  font-size: var(--text-base);
  font-weight: 500;
  display: flex;
  align-items: flex-start;
}

.OrderSummaryModal_order-summary-table__bundle-sku-list-item__ZbXZx::before {
  content: "";
  margin: 1rem 2rem 0 1rem;
  width: 0.6rem;
  height: 0.6rem;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: #000;
}

.OrderSummaryModal_order-summary-table__quantity__edv2l {
  color: var(--primary-color);
  font-size: var(--text-base);
  font-weight: 700;
}

.OrderSummaryModal_order-summary-modal__footer-content__dRgA1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.OrderSummaryModal_order-summary-modal__total-wrapper__rS6TK {
  display: flex;
  align-items: center;
  gap: 3.5rem;
}

.OrderSummaryModal_order-summary-modal__total-text__vNoTk {
  color: #000;
  font-size: var(--text-lg);
  font-weight: 500;
}

.OrderSummaryModal_order-summary-modal__total-value-wrapper__cJ1eL {
  color: var(--black-light);
  font-weight: 700;
  display: flex;
  align-items: flex-end;
  gap: 0.6rem;
}

.OrderSummaryModal_order-summary-modal__total-value__pM41N {
  font-size: var(--text-xl);
}

.OrderSummaryModal_order-summary-modal__total-currency__JIkQb {
  font-size: var(--text-base);
}

.OrderSummaryModal_order-summary-modal__footer-actions__YXM8- {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.OrderSummaryModal_order-summary-modal__edit-btn__Jdd-9 {
  padding: 1.6rem 4rem;
}

.OrderSummaryModal_order-summary-modal__confirm-btn__9hH6x {
  padding: 1rem 3rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/Modals/OrderSummaryModal/OrderSummaryModal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".order-summary-modal {\n  width: 116rem;\n  max-width: 100%;\n}\n.order-summary-modal__content {\n  max-width: 95rem;\n  margin-inline: auto;\n}\n\n.order-summary-table__item-name-title {\n  color: var(--gray-dark);\n  font-size: var(--text-sm);\n  font-weight: 500;\n  line-height: 1.8rem;\n}\n\n.order-summary-table__sku-name {\n  margin-top: 0.9rem;\n  color: #000;\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n\n.order-summary-table__bundle-skus-list {\n  margin-top: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.4rem;\n}\n\n.order-summary-table__bundle-sku-list-item {\n  color: #000;\n  font-size: var(--text-base);\n  font-weight: 500;\n  display: flex;\n  align-items: flex-start;\n}\n\n.order-summary-table__bundle-sku-list-item::before {\n  content: \"\";\n  margin: 1rem 2rem 0 1rem;\n  width: 0.6rem;\n  height: 0.6rem;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background-color: #000;\n}\n\n.order-summary-table__quantity {\n  color: var(--primary-color);\n  font-size: var(--text-base);\n  font-weight: 700;\n}\n\n.order-summary-modal__footer-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.order-summary-modal__total-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 3.5rem;\n}\n\n.order-summary-modal__total-text {\n  color: #000;\n  font-size: var(--text-lg);\n  font-weight: 500;\n}\n\n.order-summary-modal__total-value-wrapper {\n  color: var(--black-light);\n  font-weight: 700;\n  display: flex;\n  align-items: flex-end;\n  gap: 0.6rem;\n}\n\n.order-summary-modal__total-value {\n  font-size: var(--text-xl);\n}\n\n.order-summary-modal__total-currency {\n  font-size: var(--text-base);\n}\n\n.order-summary-modal__footer-actions {\n  display: flex;\n  gap: 1.5rem;\n  align-items: center;\n}\n\n.order-summary-modal__edit-btn {\n  padding: 1.6rem 4rem;\n}\n\n.order-summary-modal__confirm-btn {\n  padding: 1rem 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"order-summary-modal": `OrderSummaryModal_order-summary-modal__sYmT9`,
	"order-summary-modal__content": `OrderSummaryModal_order-summary-modal__content__4Pmni`,
	"order-summary-table__item-name-title": `OrderSummaryModal_order-summary-table__item-name-title__U28WJ`,
	"order-summary-table__sku-name": `OrderSummaryModal_order-summary-table__sku-name__FyFbl`,
	"order-summary-table__bundle-skus-list": `OrderSummaryModal_order-summary-table__bundle-skus-list__ji2uP`,
	"order-summary-table__bundle-sku-list-item": `OrderSummaryModal_order-summary-table__bundle-sku-list-item__ZbXZx`,
	"order-summary-table__quantity": `OrderSummaryModal_order-summary-table__quantity__edv2l`,
	"order-summary-modal__footer-content": `OrderSummaryModal_order-summary-modal__footer-content__dRgA1`,
	"order-summary-modal__total-wrapper": `OrderSummaryModal_order-summary-modal__total-wrapper__rS6TK`,
	"order-summary-modal__total-text": `OrderSummaryModal_order-summary-modal__total-text__vNoTk`,
	"order-summary-modal__total-value-wrapper": `OrderSummaryModal_order-summary-modal__total-value-wrapper__cJ1eL`,
	"order-summary-modal__total-value": `OrderSummaryModal_order-summary-modal__total-value__pM41N`,
	"order-summary-modal__total-currency": `OrderSummaryModal_order-summary-modal__total-currency__JIkQb`,
	"order-summary-modal__footer-actions": `OrderSummaryModal_order-summary-modal__footer-actions__YXM8-`,
	"order-summary-modal__edit-btn": `OrderSummaryModal_order-summary-modal__edit-btn__Jdd-9`,
	"order-summary-modal__confirm-btn": `OrderSummaryModal_order-summary-modal__confirm-btn__9hH6x`
};
export default ___CSS_LOADER_EXPORT___;
